import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRegionsStore = defineStore('regions', () => {

    const allRegions = ref([]);
    const chosenRegion = ref();
    const showRegions = ref(false);

    function setChosenRegion(region) {

        chosenRegion.value = region;

    }

    function updateRegions(regions) {

        allRegions.value = regions;

    }

    function setShowRegions(value) {

        showRegions.value = value;

    }

    return {
        allRegions,
        chosenRegion,
        showRegions,
        setChosenRegion,
        updateRegions,
        setShowRegions,
    }

})
